module.exports = __webpack_public_path__ + "img/papier_firmowy.aebe5693.jpg";